import { AgeVerificationStatus } from "@next-platform/packages-ts-types";
/**
 * Returns true if age verification is mandatory for the user.
 * @param ageVerificationStatus - current AgeVerificationStatus
 */
export function isAgeVerificationMandatory(ageVerificationStatus) {
    return (
    // For more information regarding those statuses, see AgeVerificationStatus enum from @next-platform/packages-ts-types
    [AgeVerificationStatus.VERIFY, AgeVerificationStatus.REVERIFY].includes(ageVerificationStatus));
}
